(function () {
  'use strict';

  var HULK_ORIGIN = 'https://formbuilder.hulkapps.com';
  var FORM_ID = '2qrKkdlmqWXr0FcShfqGww';
  var GOOGLE_ADS_ID = 'AW-11125151364';
  var GOOGLE_ADS_DESTINATION = 'AW-11125151364/tqP_CI37-OscEISt8bgp';

  function normalizedMessageData(value) {
    if (typeof value !== 'string') return value;
    try { return JSON.parse(value); } catch (error) { return null; }
  }

  function alreadyCounted(timestamp) {
    var key = 'jm_hulk_conversion_' + String(timestamp || 'unknown');
    try {
      if (window.sessionStorage.getItem(key)) return true;
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      if (window.__jmLastHulkConversion === key) return true;
      window.__jmLastHulkConversion = key;
    }
    return false;
  }

  function ensureGoogleTag() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!window.__jmGoogleAdsTagConfigured) {
      window.__jmGoogleAdsTagConfigured = true;
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js?id=' + GOOGLE_ADS_ID + '"]')) {
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GOOGLE_ADS_ID;
        document.head.appendChild(script);
      }
      window.gtag('js', new Date());
      window.gtag('config', GOOGLE_ADS_ID);
    }
  }

  function registerConversion(payload) {
    if (alreadyCounted(payload && payload.timestamp)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'hulk_form_submitted',
      form_id: FORM_ID,
      form_name: 'Cotizaciones',
      page_path: window.location.pathname
    });
    ensureGoogleTag();
    window.gtag('event', 'conversion', {
      send_to: GOOGLE_ADS_DESTINATION,
      value: 1.0,
      currency: 'CLP'
    });
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== HULK_ORIGIN) return;
    var data = normalizedMessageData(event.data);
    if (!data || data.type !== 'form_submitted') return;
    if (!data.payload || data.payload.form_id !== FORM_ID) return;
    registerConversion(data.payload);
  }, false);
})();
